/**
 * 教員画面の公開デモ（/demo/teacher）。/demo/rankings と同じ参加者データを使い、
 * 画面の並びは本物の教員画面（/teacher）と同じにする。デモの中のリンクは本物の画面に出さない。
 */
export const DEMO_TEACHER_BASE = "/demo/teacher";

/** 本物の教員画面のパス（/teacher/...）を、デモのときはデモの中のパスに置き換える */
export function teacherHref(demo: boolean, path: string): string {
  if (!demo) return path;
  if (path === "/teacher") return DEMO_TEACHER_BASE;
  return path.startsWith("/teacher/") ? `${DEMO_TEACHER_BASE}${path.slice("/teacher".length)}` : path;
}

/** デモの評価画面。戻るボタンはデモの教員画面に戻す */
export function demoEvaluationHref(interviewId: number, participantCode: string, returnTo: string): string {
  const params = new URLSearchParams({
    interview_id: String(interviewId),
    demo_participant: participantCode,
    demo_return: returnTo,
  });
  return `${DEMO_TEACHER_BASE}/evaluation?${params.toString()}`;
}

async function fetchPublic<T>(path: string, errorMessage: string): Promise<T> {
  const response = await fetch(path, { credentials: "omit" });
  if (!response.ok) throw new Error(errorMessage);
  return response.json();
}

/** デモのダッシュボードで選べる「平均点推移」の期間（週） */
export const DEMO_TREND_WEEK_OPTIONS = [8, 12, 26] as const;

export function getPublicTeacherDashboard(grade?: number | null, weeks?: number) {
  const query = new URLSearchParams();
  if (grade != null) query.set("grade", String(grade));
  if (weeks != null) query.set("weeks", String(weeks));
  return fetchPublic<unknown>(
    `/api/public/ranking-sample/dashboard${query.size > 0 ? `?${query.toString()}` : ""}`,
    "デモのダッシュボードを読み込めませんでした。",
  );
}

export interface PublicTeacherScoreRow {
  interview_id: number;
  participant_code: string;
  user_name: string;
  lecture_title: string | null;
  patient_score_value: number | null;
  dentist_score_value: number | null;
  overall_score_value: number | null;
  created: string;
}

export interface PublicTeacherScoresResponse {
  scope: "public_sample";
  scores: PublicTeacherScoreRow[];
  statistics: { avg: number; min: number; max: number; basis: "patient_score" };
  pagination: { page: number; limit: number; total: number };
}

export function getPublicTeacherScores(page: number, limit: number) {
  return fetchPublic<PublicTeacherScoresResponse>(
    `/api/public/ranking-sample/scores?page=${page}&limit=${limit}`,
    "デモの面接評価一覧を読み込めませんでした。",
  );
}
